// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4721":"9335a5ced92b657d","6088":"f586655e866aa2f9"}[chunkId] + ".js";
};